/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Available device modes.<ul><li>HAMP(0)<li>HSSP(1)</li><li>HDSP(2)</li><li>MAINTENANCE(3)</li><li>HBSP(4)</li></ul>
 */
export enum Mode {
    /**
     * HAMP
     */
    HAMP = 0,
    /**
     * HSSP
     */
    HSSP = 1,
    /**
     * HDSP
     */
    HDSP = 2,
    /**
     * MAINTENANCE
     */
    MAINTENANCE = 3,
    /**
     * HBSP
     */
    HBSP = 4,
}
